import {
    ADD_VEHICLE_COLOR,
  GET_VEHICLE_COLOR,
  GET_VEHICLE_COLOR_DETAILS,
  UPDATE_VEHICLE_COLOR,
  DELETE_VEHICLE_COLOR,
  UPDATE_VEHICLE_COLOR_STATUS,
  VEHICLE_COLOR_LIST,
} from "helpers/url_helper";
import { createCrudSlice } from "./createCrudSlice";

const vehicleColorSlice = createCrudSlice({
  name: "vehicleColor",
  urls: {
    getList: GET_VEHICLE_COLOR,
    getDropdownList: VEHICLE_COLOR_LIST,
    add: ADD_VEHICLE_COLOR,
    update: UPDATE_VEHICLE_COLOR,
    delete: DELETE_VEHICLE_COLOR,
    updateStatus: UPDATE_VEHICLE_COLOR_STATUS,
    getDetails: GET_VEHICLE_COLOR_DETAILS,
  },
  initialFilters: {},
  hasDropdownList: true,
  defaultDropdownData: [],
  additionalThunks: {},
  initialState: {
  },
});

// Export actions
export const { setFilter, resetFilters } = vehicleColorSlice.actions;

// Export thunks
export const {
  getList: getVehicleColorList,
  getDropdownList: getVehicleColorDropdownList,
  add: addVehicleColor,
  update: updateVehicleColor,
  delete: deleteVehicleColor,
  updateStatus: updateVehicleColorStatus,
  getDetails: getVehicleColorDetails,
} = vehicleColorSlice.thunks;

// Export reducer
export default vehicleColorSlice.reducer;
